import axios from "axios";
import { useContext, useEffect } from "react";
import server from "../../server";
import DashboardContext from "../Context/DashboardContext";
import AllOrders from "../Dashboard/Layout/AllOrders";
import OrderTable from "./Layout/OrderTable";
// import * as React from 'react';
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import { Spinner } from "flowbite-react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { EstoreAdminToken } from "../../../constants/constants";
import { EstoreBaseUrl } from "../../server";
import useStore from "../stores.ts";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const orderStatusMap = [
  "pending", // index 0
  "inprogress", // index 1
  "cancelled", // index 2
  "delivered", // index 3
  "all", // index 4
  "dispatch", // index 5
];

const AdminOrders = () => {
  const {
    orders,
    setOrders,
    selectedTab,
    setSelectedTab,
    productsPageNo,
    setProductsPageNo,

    pendingOrders,
    setPendingOrders,
    inprogressOrders,
    setInprogressOrders,

    dateRange,
    setDateRange,

    orderMetrics,
    setOrderMetrics,
  } = useStore();
  const navigate = useNavigate();

  // const displayOrders =
  //   orderStatusMap[selectedTab] == "pending"
  //     ? pendingOrders
  //     : orderStatusMap[selectedTab] == "inprogress"
  //       ? inprogressOrders
  //       : orders;

  const displayOrders =
    orderStatusMap[selectedTab] === "pending"
      ? pendingOrders
      : orderStatusMap[selectedTab] === "inprogress"
        ? inprogressOrders
        : orderStatusMap[selectedTab] === "cancelled"
          ? orders.filter((order) => order.status === "cancelled")
          : orderStatusMap[selectedTab] === "delivered"
            ? orders.filter((order) => order.status === "delivered")
            : orders;

  // const [customerByOrder, setcustomerByOrder] = useState([]);
  // const [origetOrder, setOriGetOrder] = useState([]);
  const context = useContext(DashboardContext);
  const { loading, setLoading } = context;
  // const [value, setValue] = useState(0);

  // const [orderMetrics, setOrderMetrics] = useState([]);
  // const [selectedPeriod, setSelectedPeriod] = useState("day");

  const handleChange = (event, newValue) => {
    setProductsPageNo(0);
    // setValue(newValue);
    setSelectedTab(newValue);
  };

  // const [dateRange, setDateRange] = useState({
  //   from: new Date().toISOString().split("T")[0],
  //   to: new Date().toISOString().split("T")[0],
  // });

  // const requestOptions = {
  //   headers: {
  //     method: "GET",
  //     Authorization: `Bearer ${localStorage.getItem("access")}`,
  //   },
  // };

  const dataOrders = async (initial = false) => {
    if (orders?.length && initial) return;
    setLoading(true);
    const resPending = await axios.get(`${server}/orders`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
      params: { status: "pending", ...dateRange },
    });

    const resInProg = await axios.get(`${server}/orders`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
      params: { status: "inprogress", ...dateRange },
    });

    const res = await axios.get(`${server}/orders`, {
      params: { ...dateRange },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    });

    const resMet = await axios.get(`${server}/orders/metrics`, {
      params: { ...dateRange },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    });
    setOrderMetrics(resMet.data);

    const estorePending = await axios.get(`${EstoreBaseUrl}/vendor/orders`, {
      headers: {
        Authorization: `Bearer ${EstoreAdminToken}`,
      },
      params: { status: "pending", ...dateRange },
    });

    const combinedPending = [...resPending.data, ...estorePending.data];
    setPendingOrders(combinedPending);

    const esotreInProgress = await axios.get(`${EstoreBaseUrl}/vendor/orders`, {
      headers: {
        Authorization: `Bearer ${EstoreAdminToken}`,
      },
      params: { status: "confirmed", ...dateRange },
    });

    const combinedProgress = [...resInProg.data, ...esotreInProgress.data];

    setInprogressOrders(combinedProgress);

    const estoreOrders = await axios.get(`${EstoreBaseUrl}/vendor/orders`, {
      headers: {
        Authorization: `Bearer ${EstoreAdminToken}`,
      },
      params: { ...dateRange },
    });

    const combinedOrders = [...res.data, ...estoreOrders.data];
    setOrders(combinedOrders);

    setLoading(false);
  };

  useEffect(() => {
    if (!localStorage.getItem("adminuser")) navigate("/");
    // else if (!loading) dataOrders();
  }, [dateRange]);

  // useEffect(() => {}, [value, orders]);

  useEffect(() => {
    console.log({ selectedTab });
    console.log({ t: orderStatusMap[selectedTab] });
  }, [selectedTab]);

  // useEffect(() => {
  //   async function p() {
  //     const resMet = await axios.get(`${server}/orders/metrics`, {
  //       params: { period: selectedPeriod },
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
  //       },
  //     });
  //     setOrderMetrics(resMet.data);
  //   }
  //   p();
  // }, [selectedPeriod]);

  return (
    <div>
      <div className="order-head px-3">
        <p className="order-title">Orders Summary</p>{" "}
        {/* <div className="flex items-center gap-3">
          <label htmlFor="periods" className="font-medium">
            Select a period:
          </label>
          <select
            id="periods"
            value={selectedPeriod}
            onChange={(event) => {
              setSelectedPeriod(event.target.value);
            }}
            className="border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">All</option>
            <option value="day">Day</option>
            <option value="week">Week</option>
            <option value="month">Month</option>
            <option value="year">Year</option>
          </select>
        </div> */}
        {/* <DateRangePicker value={dateRange} onChange={setDateRange} /> */}
      </div>
      {/* <div className="order-grid"> */}
      <div className="allorders">
        <AllOrders orders={orderMetrics} type={"Orders"} />
      </div>
      {/* </div> */}

      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={selectedTab}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="Pending" {...a11yProps(0)} />
            <Tab label="In Progress" {...a11yProps(1)} />
            <Tab label="Cancelled " {...a11yProps(2)} />
            <Tab label="Delivered" {...a11yProps(3)} />
            <Tab label="All Orders" {...a11yProps(4)} />
            <Tab label="Dispatch Requests" {...a11yProps(5)} />
          </Tabs>
        </Box>
        {displayOrders.length == 0 ? (
          <div className="flex items-center justify-center h-full w-full">
            No orders
          </div>
        ) : displayOrders.length > 0 ? (
          <>
            <CustomTabPanel value={selectedTab} index={0}>
              <OrderTable
                getOrder={displayOrders}
                orderstatus="pending"
                functionchange={dataOrders}
                pageNo={productsPageNo}
                setPageNo={setProductsPageNo}
              />
            </CustomTabPanel>
            <CustomTabPanel value={selectedTab} index={1}>
              <OrderTable
                getOrder={displayOrders}
                orderstatus="inprogress"
                functionchange={dataOrders}
                pageNo={productsPageNo}
                setPageNo={setProductsPageNo}
              />
            </CustomTabPanel>
            <CustomTabPanel value={selectedTab} index={2}>
              <OrderTable
                getOrder={displayOrders}
                orderstatus="cancelled"
                functionchange={dataOrders}
                pageNo={productsPageNo}
                setPageNo={setProductsPageNo}
              />
            </CustomTabPanel>
            <CustomTabPanel value={selectedTab} index={3}>
              <OrderTable
                getOrder={displayOrders}
                orderstatus="delivered"
                functionchange={dataOrders}
                pageNo={productsPageNo}
                setPageNo={setProductsPageNo}
              />
            </CustomTabPanel>
            <CustomTabPanel value={selectedTab} index={4}>
              <OrderTable
                getOrder={displayOrders}
                orderstatus="all"
                functionchange={dataOrders}
                pageNo={productsPageNo}
                setPageNo={setProductsPageNo}
              />
            </CustomTabPanel>
            <CustomTabPanel value={selectedTab} index={5}>
              <OrderTable
                getOrder={displayOrders}
                orderstatus="pending"
                functionchange={dataOrders}
                dispatch={"dispatch"}
                pageNo={productsPageNo}
                setPageNo={setProductsPageNo}
              />
            </CustomTabPanel>
          </>
        ) : (
          <div className="flex h-[80vh] w-full justify-center items-center">
            <Spinner size="xl" />
          </div>
        )}
      </Box>
      {/* <div>
        <OrderTable getOrder={getOrder} />
      </div> */}
    </div>
  );
};

export default AdminOrders;
